import React from 'react'
import CustomImage from '../../components/customImage/customImage'
import InComponentLoader from '../../components/InComponentLoader'
import { isEmpty } from 'lodash'
import useTemplateHook from '../../components/template/templateHook'
import { getProductImage } from '../../utils/helper'
import getSymbolFromCurrency from 'currency-symbol-map'
import { useNavigate } from 'react-router'
// import StarIcon from '../../assets/rating-star-icon.svg'

const RelatedProduct = ({ data, loading }) => {
  const navigate = useNavigate()
  const { getTemplateImage } = useTemplateHook()

  return (
    <div className="w-full">
      <InComponentLoader loading={loading} />
      <div className="mx-auto ">
        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-6 py-5 md:py-10 xl:py-6">
          {!isEmpty(data) &&
            data.map((item, index) => (
              <div
                key={item._id}
                className="relative group cursor-pointer "
                onClick={() => navigate(`/product/${item._id}`)}
              >
                <div className=" ">
                  {/* Image Container */}
                  <div className="relative">
                    <CustomImage
                      imageUrl={getTemplateImage(getProductImage(item?.img_s3_keys))}
                      imgAlt={item.title}
                      imgClass="w-full h-full object-cover"
                      loaderClass="w-full h-full"
                      imgStyle={{ borderRadius: '10px' }}
                    />
                  </div>
                  {/* Content */}
                  <div className="py-2">
                    <p className="text-white text-[10px] sm:text-sm md:text-base font-semibold line-clamp-2">
                      {item.title}
                    </p>

                    {/* Price Section */}
                    <div className="flex items-center gap-2 mt-2 flex-wrap">
                      <span className="bg-[#ff6600] text-white rounded text-[10px] sm:text-xs md:text-sm px-1 py-[2px] font-semibold">
                        {item?.discount?.enabled
                          ? parseInt(
                              item?.price -
                                (item?.price * parseInt(item?.discount.discount_value)) / 100,
                            )
                          : parseInt(item?.price)}{' '}
                        {getSymbolFromCurrency(item.currency || 'USD')}
                      </span>

                      {item?.discount?.enabled && (
                        <>
                          <span
                            className="text-[10px] sm:text-xs md:text-sm line-through"
                            style={{ color: '#808080' }}
                          >
                            {item.price} {getSymbolFromCurrency(item.currency || 'USD')}
                          </span>

                          <span className=" text-[#ff6600] text-[10px] sm:text-xs md:text-sm font-semibold">
                            ({item?.discount.discount_value}
                            {item?.discount.value_type === 'percentage' ? '%' : ''}) OFF
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  )
}

export default RelatedProduct
